module.exports = __webpack_public_path__ + "84b1e3c32e94fa42a01b991ce57ca82d.svg";